export default {
  name: 'QuestionMark',
  functional: true,
}
